// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import { isNil } from 'lodash';

import { MrModal } from '@ion/components';

import { usePipelineIntegrationModalContext } from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/PipelineIntegrationsTable/context/pipeline-integration-modal-context';

import { AddIntegration } from './options/add-integration/AddIntegration';
import { EditIntegration } from './options/edit-integration/EditIntegration';

export const PIPELINE_MODAL_OPTIONS = {
  addIntegration: 'addIntegration',
  editIntegration: 'editIntegration',
};
export const PipelineModal = () => {
  const { isOpenModal, onCloseModal, modalContentOption } = usePipelineIntegrationModalContext();
  const isOpen = determineIsOpen({ isOpenModal, modalContentOption });
  if (isNil(!isOpen)) {
    return null;
  }

  const renderContent = () => {
    switch (modalContentOption) {
      case PIPELINE_MODAL_OPTIONS.addIntegration:
        return <AddIntegration />;
      case PIPELINE_MODAL_OPTIONS.editIntegration:
        return <EditIntegration />;
      default:
        throw new Error('Invalid modal option');
    }
  };

  return (
    <>
      {isOpen && (
        <MrModal styleNames="allowOverflow" closeModal={onCloseModal}>
          {renderContent()}
        </MrModal>
      )}
    </>
  );
};

function determineIsOpen({ isOpenModal, modalContentOption }) {
  const isPipelineModal =
    modalContentOption === PIPELINE_MODAL_OPTIONS.addIntegration ||
    modalContentOption === PIPELINE_MODAL_OPTIONS.editIntegration;

  const isOpen = Boolean(isOpenModal && isPipelineModal);

  return isOpen;
}
